/**
 * Thumbnails API call, maps to the Django endpoint in api/urls.py.
 */
import api from './client';

/** Returns { thumbnails } — the full list of carousel items from the database. */
export const fetchThumbnails = () => api.get('/api/thumbnails/');